export const practitionerActivityRightFields = [
  {
    name: 'scheduledAppointments',
    label: 'Nombre de rendez-vous planifiés (Agenda) :',
    placeholder: 'Ex : 95',
    required: true
  },
  {
    name: 'patientsTreated',
    label: 'Nombre de patients soignés :',
    placeholder: 'Ex : 80',
    required: true
  },
  {
    name: 'emergencies',
    label: 'Nombre d’urgences :',
    placeholder: 'Ex : 2',
    required: true
  },
  {
    name: 'treatmentPlansAccepted',
    label: 'Nombre de plans de traitement acceptés :',
    placeholder: 'Ex : 17',
    required: true
  },
  {
    name: 'implantsPlaced',
    label: 'Nombre d’implants posés :',
    placeholder: 'Ex : 0',
    required: true
  },
  {
    name: 'revenue',
    label: 'Chiffre d’affaires réalisé :',
    placeholder: 'Ex : 39500',
    end: '€',
    required: true
  }
];
